import React, { useEffect, useState } from 'react';
import ToastMessage from '../../components/ToastMessage';
import { PageContainer } from '../SchoolManagement/styled';
import { Typography } from '@mui/material';
import { SnackbarSeverityType } from '../../enums';
import { getSchoolClassesConfig } from '../../apis/schoolConfig';
import { SchoolClassesConfig } from '../../types/schoolConfigType';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import StudentProfilePage from './StudentProfilePage';

const StudentProfileContainer = () => {
  const [allClasses, setAllClasses] = useState<SchoolClassesConfig>();
  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState<SnackbarSeverityType>(
    SnackbarSeverityType.success
  );
  const [isLoadingConfig, setIsLoadingConfig] = useState(true);

  const handleCloseToast = () => {
    setToastOpen(false);
  };

  const showToast = (message: string, severity: SnackbarSeverityType) => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  useEffect(() => {
    getSchoolClassesConfig(loggedInUser.school)
      .then((response) => {
        setAllClasses(response.data as SchoolClassesConfig);
      })
      .catch((error) => {
        console.error(error);
        showToast(
          'Failed to load school configuration.',
          SnackbarSeverityType.error
        );
      })
      .finally(() => {
        setIsLoadingConfig(false);
      });
  }, [loggedInUser.school]);

  if (isLoadingConfig) {
    return (
      <PageContainer>
        <Typography>Loading student profile</Typography>
      </PageContainer>
    );
  }
  return (
    <div>
      <StudentProfilePage
        allClasses={allClasses}
        onShowToast={showToast}
      />
      <ToastMessage
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={handleCloseToast}
      />
    </div>
  );
};

export default StudentProfileContainer;
